module.exports = __webpack_public_path__ + "static/img/guards.71c8975.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/guards.jpg
// module id = LVN1
// module chunks = 0